import BonusSaleReportPage from '../../../../shared/reportBonusSale/BonusSaleReportPage'
import {ReportBonusSaleConfig} from '../../../../shared/reportBonusSale/ReportBonusSaleConfig'

const config: ReportBonusSaleConfig = {
  reportsBaseUrl: '/api/kpi/reports',
  apiEndpoint: 'bonus-sales',
  exportEndpoint: 'bonus-sales/export',
  exportFileName: 'Relatorio_vendas_bonus_kpi.xlsx',
  pageTitle: 'Relatório de Vendas Bonus',
  breadcrumbPath: '/kpi/reports/reportBonusSale/list',
  navigationPath: '/kpi/reports/reportBonusSaleDetail/list',
  navigationPermission: 'kpi.bonus_sale_items',
  navigationLabel: 'Detalhado',
  navigationIcon: 'sort',
  isKpi: true,
  showFranchiseFilter: true,
  showClientAlertIcons: false,
  showPaymentsChart: false,
  useSwalErrorHandling: true,
  authPermission: 'kpi.bonus_sales',
  exportPermission: 'kpi.export',
  dateField: 'contractAt',
  reportType: 'summary',
}

const ReportBonusSalePage = () => <BonusSaleReportPage config={config} />

export default ReportBonusSalePage
